import React from 'react';
import {
  Paper,
  Typography,
  Box,
  Grid
} from '@mui/material';
import { Star } from '@mui/icons-material';
import DashboardModuleCard from './DashboardModuleCard';
import DashboardModuleListItem from './DashboardModuleListItem';
import { getModuleById } from './dashboardConfig';

/**
 * Pinned favorites section displaying user's starred modules
 * Shows at the top of the dashboard when user has pinned modules
 */
const PinnedFavoritesSection = ({
  pinnedModuleIds = [],
  viewMode = 'card',
  onModuleClick,
  onPinToggle,
  badgeCounts = {}
}) => {
  // Get full module data for pinned IDs
  const pinnedModules = pinnedModuleIds
    .map(id => getModuleById(id))
    .filter(Boolean);

  if (pinnedModules.length === 0) {
    return null;
  }

  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        mb: 3,
        borderRadius: 2,
        bgcolor: 'warning.light',
        border: '2px solid',
        borderColor: 'warning.main'
      }}
    >
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Star sx={{ color: 'warning.dark' }} />
        <Typography variant="h6" sx={{ fontWeight: 600, color: 'warning.dark' }}>
          Pinned Favorites
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ ml: 'auto' }}>
          {pinnedModules.length} {pinnedModules.length === 1 ? 'module' : 'modules'}
        </Typography>
      </Box>

      {viewMode === 'card' ? (
        <Grid container spacing={2}>
          {pinnedModules.map(module => (
            <Grid item xs={12} sm={6} md={4} lg={3} key={module.id}>
              <DashboardModuleCard
                module={module}
                onClick={() => onModuleClick(module)}
                isPinned={true}
                onPinToggle={() => onPinToggle(module.id)}
                badge={module.badgeKey ? badgeCounts[module.badgeKey] : null}
              />
            </Grid>
          ))}
        </Grid>
      ) : (
        <Box>
          {pinnedModules.map(module => (
            <DashboardModuleListItem
              key={module.id}
              module={module}
              onClick={() => onModuleClick(module)}
              isPinned={true}
              onPinToggle={() => onPinToggle(module.id)}
              badge={module.badgeKey ? badgeCounts[module.badgeKey] : null}
            />
          ))}
        </Box>
      )}
    </Paper>
  );
};

export default PinnedFavoritesSection;
